import { IconType } from 'icons';

export const LiveSvg: React.FC<IconType> = props => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    style={props.style}
  >
    <circle cx="320.64" cy="255.34" r="62.29" />
    <path
      fill={props.color}
      d="M215.52,358.13a26,26,0,0,0,4-31.38C209.1,309,194.81,280.2,194.81,256.13c0-29.18,12.31-53.75,22.6-69.19a26,26,0,0,0-4.06-33.67l-13.81-12.61a26,26,0,0,0-38.4,3.68c-17.3,23.38-36.2,61.2-36.2,111.79,0,51.43,21,89.94,37.54,112.75A26,26,0,0,0,202,371.83Z"
    />
    <path
      fill={props.color}
      d="M425,358.13a26,26,0,0,1-4-31.38c10.39-17.75,24.68-46.55,24.68-70.62,0-29.18-12.31-53.75-22.6-69.19a26,26,0,0,1,4.06-33.67l13.81-12.61a26,26,0,0,1,38.41,3.68c17.29,23.38,36.19,61.2,36.19,111.79,0,51.43-21,89.94-37.54,112.75a26,26,0,0,1-39.48,2.95Z"
    />
    <path
      fill={props.color}
      d="M126.26,445.16a26,26,0,0,0,2-35.38C107,384.24,76.48,347.34,71.62,255.46,69.21,210,82.93,163.82,129.1,100.74a26,26,0,0,0-3.19-34.19l-13.77-13a26,26,0,0,0-37.78,2.22C28.79,110.48-2.9,192.29.31,263.45c4,88.28,36.9,148.32,74.54,193a25.94,25.94,0,0,0,37.76,1.85Z"
    />
    <path
      fill={props.color}
      d="M513.74,445.16a26,26,0,0,1-2-35.38c21.25-25.54,51.77-62.44,56.63-154.32,2.41-45.47-11.31-91.64-57.48-154.72a26,26,0,0,1,3.19-34.19l13.77-13a26,26,0,0,1,37.78,2.22c45.57,54.69,77.26,136.5,74.05,207.66-4,88.28-36.9,148.32-74.54,193a25.94,25.94,0,0,1-37.76,1.85Z"
    />
  </svg>
);

LiveSvg.defaultProps = {
  color: 'currentColor',
};
